var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Retornar Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", [
        _c("span", { staticClass: "chip-custom" }, [
          _vm._v(
            " Por Favor deja un comentario sobre el motivo de la devolución del expediente "
          )
        ]),
        _c(
          "div",
          { staticClass: "wrap-commentary" },
          [
            _c("vs-textarea", {
              attrs: { maxlength: "255", label: "Comentario" },
              model: {
                value: _vm.commentary,
                callback: function($$v) {
                  _vm.commentary = $$v
                },
                expression: "commentary"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "m-top-20",
          staticStyle: { display: "flex", "justify-content": "flex-end" }
        },
        [
          _c(
            "vs-button",
            {
              attrs: { color: "dark", type: "border" },
              on: {
                click: function($event) {
                  return _vm.cancelProcess()
                }
              }
            },
            [_vm._v("Cancelar")]
          ),
          _c(
            "vs-button",
            {
              staticClass: "ml-3",
              attrs: { color: "primary", type: "border" },
              on: {
                click: function($event) {
                  return _vm.returnFile()
                }
              }
            },
            [_vm._v(" Si, devolver ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }